import { useUpdateInboxTagMutation } from '../../services/inbox.service';
import { Tags } from '../../models';

export const useToggleFoundTag = () => {
  const [updateInboxTag, { isLoading }] = useUpdateInboxTagMutation();

  const toggleFoundTag = async (inboxId: string, currentTags?: string) => {
    if (!inboxId) return;

    await updateInboxTag({
      inboxId,
      tag: Tags.FOUND,
    }).unwrap();

    const tagsArray = currentTags
      ? currentTags.split(',').map((t) => t.trim())
      : [];
    const hadFoundTag = tagsArray.includes(Tags.FOUND);

    return !hadFoundTag;
  };

  return {
    toggleFoundTag,
    isLoading,
  };
};
